module.exports = __webpack_public_path__ + "img/qr.c9589d25.png";